module.exports = __webpack_public_path__ + "img/FS_FireSword.e1395686.png";